import { j as e } from "./jsx-runtime-DywqP_6a.js";
import { b as m, j as h } from "./ZudokuContext-BcqSiygJ.js";
import { N as g, L as y } from "./chunk-PVWAREVJ-BO6B-RAk.js";
import { u as _ } from "./index-CVfG8Pb4.js";
import { O as d } from "./errors-ouIp07AW.js";
import { HomeIcon as v } from "lucide-react";
import { H as f, T as o } from "./ErrorAlert-xpVkFS_n.js";
import { Button as c } from "./ui/Button.js";
import { a as x } from "./hook-BkLXq8pm.js";
function w(r, i, n = "/") {
  return r.startsWith(i) ? n !== "/" && r.startsWith(i + n) ? r.slice(i.length + n.length) : r.slice(i.length) : r;
}
function U({
  handleCallback: r
}) {
  const { options: i } = _(), n = m({
    retry: !1,
    queryKey: ["oauth-callback"],
    queryFn: async () => {
      const a = new URL(window.location.href), t = a.searchParams.get("error"), s = a.searchParams.get("error_description") ?? void 0, p = a.searchParams.get("error_uri") ?? void 0;
      if (t)
        throw new d(
          `OAuth error '${t}': ${s}`,
          {
            error: t,
            error_description: s,
            error_uri: p
          }
        );
      return h(
        w(
          await r(),
          window.location.origin,
          i.basePath
        )
      );
    }
  });
  return /* @__PURE__ */ e.jsx(g, { to: n.data, replace: !0 });
}
const l = {
  invalid_request: {
    message: "The authentication request was invalid. Please try signing in again."
  },
  unauthorized_client: {
    message: "This application is not authorized to access your account. Please contact support."
  },
  access_denied: {
    message: "You denied access to this application. To continue, please sign in and grant access."
  },
  unsupported_response_type: {
    message: "The authentication method is not supported. Please contact support."
  },
  invalid_scope: {
    message: "The requested permissions are invalid. Please contact support."
  },
  server_error: {
    message: "The authentication server encountered an error. Please try again in a few moments."
  },
  temporarily_unavailable: {
    message: "The authentication service is temporarily unavailable. Please try again in a few moments."
  },
  // Token errors
  invalid_client: {
    message: "Invalid application credentials. Please contact support."
  },
  invalid_grant: {
    message: "The authentication code has expired or is invalid. Please sign in again."
  },
  unsupported_grant_type: {
    message: "The authentication method is not supported. Please contact support."
  },
  // Custom errors
  invalid_state: {
    message: "Security validation failed. This may be due to a potential security attack. Please try signing in again."
  },
  missing_code_verifier: {
    message: "Authentication security information is missing. Please clear your browser cache and try again."
  },
  network_error: {
    message: "A network error occurred during authentication. Please check your connection and try again."
  },
  token_expired: {
    message: "Your authentication session has expired. Please sign in again."
  },
  configuration_error: {
    message: "There is an issue with the authentication configuration. Please contact support."
  },
  unknown_error: {
    message: "An unexpected error occurred during authentication. Please try again or contact support."
  }
};
function q({ error: r }) {
  const { login: i } = x();
  if (!(r instanceof d))
    throw r;
  const a = r.error.error, t = l[a] ?? l.unknown_error;
  return /* @__PURE__ */ e.jsx("div", { className: "min-h-[400px] flex items-center justify-center p-4", children: /* @__PURE__ */ e.jsxs("div", { className: "max-w-md w-full text-center space-y-6", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "space-y-4 items-center", children: [
      /* @__PURE__ */ e.jsx(f, { level: 2, className: "text-2xl inline-block font-bold", children: k[a] || "Authentication Error" }),
      /* @__PURE__ */ e.jsx(o, { className: "text-gray-600 dark:text-gray-300 leading-relaxed", children: t?.message })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "space-y-3 pt-4", children: [
      /* @__PURE__ */ e.jsx("div", { className: "space-y-2", children: (a === "access_denied" || a === "invalid_grant" || a === "token_expired") && /* @__PURE__ */ e.jsx(
        c,
        {
          onClick: i,
          className: "w-full capitalize",
          variant: "default",
          children: "Sign in again"
        }
      ) }),
      /* @__PURE__ */ e.jsx("div", { className: "flex gap-2", children: /* @__PURE__ */ e.jsx(c, { asChild: !0, className: "flex-1", variant: "outline", children: /* @__PURE__ */ e.jsxs(y, { to: "/", children: [
        /* @__PURE__ */ e.jsx(v, { className: "w-4 h-4 mr-2" }),
        "Go Home"
      ] }) }) })
    ] }),
    u[a] && /* @__PURE__ */ e.jsx(o, { className: "text-sm text-gray-500 dark:text-gray-400", children: u[a] })
  ] }) });
}
const k = {
  access_denied: "Access Denied",
  invalid_request: "Invalid Request",
  unauthorized_client: "Unauthorized Application",
  unsupported_response_type: "Unsupported Method",
  invalid_scope: "Invalid Permissions",
  server_error: "Server Error",
  temporarily_unavailable: "Service Unavailable",
  invalid_client: "Invalid Credentials",
  invalid_grant: "Authentication Expired",
  unsupported_grant_type: "Unsupported Authentication",
  invalid_state: "Security Check Failed",
  missing_code_verifier: "Security Information Missing",
  network_error: "Network Error",
  token_expired: "Session Expired",
  configuration_error: "Configuration Error",
  unknown_error: "Authentication Failed"
}, u = {
  access_denied: "If you changed your mind, you can try signing in again to grant access.",
  invalid_state: "This error can occur if you have multiple tabs open or if your session was compromised.",
  missing_code_verifier: "Try clearing your browser's cache and cookies for this site.",
  network_error: "Check your internet connection and ensure you can access other websites.",
  server_error: "The issue is on our end. Our team has been notified and is working to fix it.",
  temporarily_unavailable: "This is usually temporary. Try again in a few minutes."
};
export {
  U as C,
  q as O
};
//# sourceMappingURL=OAuthErrorPage-DCjFngGS.js.map
